// import { Control, Controller } from "react-hook-form";
// import { AgendaUser } from "../../graphql/API";
// import { Text, TextInput, View } from "react-native";
// import styles from "./styles";

// export type IEditableUserField = 'username' | 'firstName' | 'lastName' | 'phoneNumber' | 'role' | 'type'; //| 'night' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';
// export type IEditableUser = Pick<AgendaUser, IEditableUserField>;

// interface ICustomInput {
//     label: string;
//     multiline?: boolean;
//     control: Control<IEditableUser, object>; // <IUser, object>;
//     name: IEditableUserField; // string;
//     rules?: object;
//     startPlaceholder: string;
// };

// const CustomInput = ({control, name, label, rules = {}, multiline = false, startPlaceholder = "Enter your "}: ICustomInput) => {
//     return (
//         <Controller
//             control={control}
//             name={name}
//             rules={rules} // {{ required: true }}
//             render={({field: {onChange, value, onBlur, name, ref}, fieldState: {invalid, isTouched, isDirty, error}}) => {
//                 return (
//                     <View style={styles.inputContainer}>
//                         <Text style={styles.label}>{label}</Text>
//                         <View style={{flex:1}}>
//                             {/* { typeof value === 'string' || value === null && */}
//                                     <TextInput
//                                         value={value || ''}
//                                         onChangeText={onChange}
//                                         onBlur={onBlur}
//                                         placeholder={startPlaceholder + label}
//                                         placeholderTextColor="#AAA" 
//                                         style={[error ? styles.errorInput : styles.input, ]} 
//                                         multiline={multiline}
//                                     />
//                             {/* } */}
 
//                             {error && <Text style={styles.error}>{error.message || error.type}</Text>}
//                         </View>
//                     </View>

//             )}}
//         />
//     )
// };

// export default CustomInput;

import { Control, Controller } from "react-hook-form";
import { AgendaUser } from "../../graphql/API";
import React from "react";

export type IEditableUserField = 'username' | 'firstName' | 'lastName' | 'phoneNumber' | 'role' | 'type';
export type IEditableUser = Pick<AgendaUser, IEditableUserField>;

interface ICustomInput {
    label: string;
    multiline?: boolean;
    control: Control<IEditableUser, object>;
    name: IEditableUserField;
    rules?: object;
    startPlaceholder: string;
}

const styles = {
    inputContainer: {
        marginBottom: "1rem",
        width: "100%",
    },
    label: {
        display: "block",
        fontWeight: 600,
        marginBottom: "0.5rem"
    },
    input: {
        width: "100%",
        padding: "0.5rem",
        borderRadius: "5px",
        border: "1px solid #ccc",
        fontSize: "1rem"
    },
    errorInput: {
        border: "1px solid red"
    },
    error: {
        color: "red",
        fontSize: "0.875rem",
        marginTop: "0.25rem"
    }
} as const;

const CustomInput = ({ control, name, label, rules = {}, multiline = false, startPlaceholder = "Enter your " }: ICustomInput) => {
    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
                <div style={styles.inputContainer}>
                    <label style={styles.label}>{label}</label>
                    {
                        multiline ? (
                            <textarea
                                value={value ?? ''}
                                onChange={onChange}
                                // onBlur={onBlur}
                                // onChange={e => onChange(e.target.value)}
                                // onBlur={e => onBlur(e)} 
                                placeholder={`${startPlaceholder}${label}`}
                                style={{
                                    ...styles.input,
                                    ...(error ? styles.errorInput : {})
                                }}
                                rows={4}
                            />
                        ) : (
                            <input
                                type="text"
                                value={value ?? ''}
                                onChange={onChange}
                                // onBlur={onBlur}
                                // onChange={e => onChange(e.target.value)}
                                // onBlur={e => onBlur()}
                                placeholder={`${startPlaceholder}${label}`}
                                style={{
                                    ...styles.input,
                                    ...(error ? styles.errorInput : {})
                                }}
                            />
                        )
                    }
                    {error && <div style={styles.error}>{error.message || error.type}</div>}
                </div>
            )}
        />
    );
};

export default CustomInput;
